import { schema } from "normalizr";

const RecipientSchema = new schema.Entity("recipients");
const RecipientArraySchema = new schema.Array(RecipientSchema);

export { RecipientSchema, RecipientArraySchema };